import type { PropsWithChildren, ReactNode } from 'react';

import { cn } from '../utils/entry.js';

type CouponEventProps = PropsWithChildren<{
  className?: string;
  hasMultipleCoupons?: boolean;
}>;

/**
 * A wrapper for each coupon event.
 *
 * @param root0 the input props
 * @param root0.children react nodes to pass down
 * @param root0.className classes to apply to the parent
 * @param root0.hasMultipleCoupons boolean if the coupon has multiple coupons
 * @returns component.
 */
export default function CouponEvent({ children, className, hasMultipleCoupons }: CouponEventProps): ReactNode {
  const classNames = hasMultipleCoupons
    ? [
        "[grid-template-areas:'badge_description']",
        'grid-cols-[fit-content(100%)_minmax(100px,_1fr)]',
        'lg:grid-cols-[fit-content(100%)_minmax(180px,_1fr)]',
        'gap-1 lg:gap-3',
      ]
    : [
        "[grid-template-areas:'badge_description']",
        'grid-cols-[fit-content(100%)_minmax(100px,_1fr)]',
        'sm:grid-cols-[30px_minmax(fit-content(100%),_auto)]',
        "sm:[grid-template-areas:'badge_description']",
        "lg:[grid-template-areas:'badge_description']",
        'gap-1 lg:gap-3',
      ];
  return (
    <div className={cn('grid', className && className.length > 0 ? className : classNames.join(' '))}>{children}</div>
  );
}
